"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _detectNode = _interopRequireDefault(require("detect-node"));

var LazyBoundary = function LazyBoundary(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_react.default.Fragment, null, children);
};

LazyBoundary.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};

var _default = _detectNode.default ? LazyBoundary : _react.default.Suspense;

exports.default = _default;